import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import "moment/locale/ru";
import {
    getArrayToObject,
    getCustomPage
} from "../../store/directories/selectors";
import { useSelector } from "react-redux";
import classNames from 'classnames';
import { ProfilePayload } from "../../models/userModels";
import { useActions } from "../../hooks/actions";
import { supportChatIdSelector } from "../../store/support/support.selectors";
import SubMenu from '../../components/SubMenu';
import { TranslationObject } from '../../models/translationModal';
import { ChatContainer, ChatForm, ChatWindow } from '../OrderChat/elements';
import ChatsSidebar from '../../components/ChatsSidebar';
import { IChatPayload, ISupportMessage } from "../../models/chatModels";

import {
    endpoints as supportEndpoints,
    useCreateNewChatMutation,
    // useSendMessageToChatMutation,
} from "../../store/support/support.api";

const appendBanMessageFromChatInfo = (
    chatInfo: IChatPayload | undefined,
    addSupportMessage: (message: { date: string; messages: ISupportMessage[] }) => void,
) => {
    if (!chatInfo?.chat_banned || !chatInfo?.ban_message?.message) {
        return;
    }

    const banMessage = chatInfo.ban_message;
    const banMessageDate = moment
        .utc(banMessage.created_at)
        .local()
        .locale("ru")
        .format("D MMMM");

    addSupportMessage({
        date: banMessageDate,
        messages: [{
            ...banMessage,
            is_your: false,
            text: banMessage.message,
            message: banMessage.message,
        }],
    });
};

const Support: React.FC<{
    entities: TranslationObject;
    profile?: ProfilePayload;
}> = ({ entities, profile }) => {
    const HEADER_ID = 12
    const isSupport = true;
    const { id: userId, user_role: role } = profile || {};
    const isAuth = !!userId;
    const { setSupportId, setHeaderStateSearch, setSupportChatBanned, addSupportMessage } = useActions();
    const [getChat, { data: chat }] = supportEndpoints.getChatInfo.useLazyQuery();
    const [createNewChat, { data: newChat }] = useCreateNewChatMutation();
    const chatId = useSelector(supportChatIdSelector);
    const result = getCustomPage({ id: HEADER_ID });
    const headerData = result.data;
    const chID = newChat?.id || chatId;
    // const { role } = useParams();
    const navigate = useNavigate();
    const back = () => navigate(-1);

    useEffect(() => {
        if (newChat?.id) {
            setSupportId(newChat?.id || 0);
        }

        setSupportChatBanned(!!newChat?.chat_banned);

        if (newChat?.chat_banned) {
            appendBanMessageFromChatInfo(newChat, addSupportMessage);
        }
    }, [newChat]);

    useEffect(() => {
        setSupportChatBanned(!!chat?.chat_banned);

        if (chat?.chat_banned) {
            appendBanMessageFromChatInfo(chat, addSupportMessage);
        }
    }, [chat]);

    useEffect(() => {
        if (!isAuth || !chatId) {
            return;
        }

        const refetchChatInfo = (): void => {
            if (document.visibilityState === "visible") {
                getChat(chatId);
            }
        };

        document.addEventListener("visibilitychange", refetchChatInfo);

        return () => document.removeEventListener("visibilitychange", refetchChatInfo);
    }, [chatId, isAuth, getChat]);

    useEffect(() => {
        if (!isAuth) {
            return;
        }

        if (chatId) {
            getChat(chatId);
        } else {
            createNewChat();
        }
    }, [chatId, isAuth]);

    useEffect(() => {
        if (headerData && headerData?.blocks) {
            const headerBlocks = getArrayToObject(headerData?.blocks || []);
            setHeaderStateSearch(headerBlocks?.header_search_button);
        }
    }, [headerData]);

    return (
        <>
            <main>
                <div
                    className={classNames('page', {
                        'specialist-chat': role === 'specialist',
                        'customer-chat': role === 'customer',
                    })}
                >
                    <SubMenu entities={entities} />
                    <div className='container'>
                        <div className='order-information page__intro'>
                            <div className='order-information__header'>
                                <span></span>
                                <div className='order-information__buttons'>
                                    <button
                                        className='btn order-information__button order-information__button--dotts'
                                        onClick={back}
                                    >{entities?.order_details?.value}</button>
                                </div>
                                <h2 className='title title--h2'>{entities?.support_title?.value}</h2>
                            </div>
                        </div>
                    </div>

                    <ChatContainer entities={entities}>
                        <div className='chat__header'></div>
                        <ChatsSidebar
                            classNames={'chat__pinned'}
                            showIfNotChats={true}
                            // id={+orderId}
                            entities={entities}
                            // profile={profile}
                        />
                        <ChatWindow
                            userId={userId}
                            chatId={isAuth ? chID : undefined}
                            role={role}
                            entities={entities}
                            isSupport={isSupport}
                            isAuth={isAuth}
                        />
                        <ChatForm
                            role={role}
                            // orderId={orderId}
                            chatId={isAuth ? chID : undefined}
                            entities={entities}
                            isSupport={isSupport}
                            isAuth={isAuth}
                        />
                    </ChatContainer>
                </div>
            </main>
        </>
    )
}

export default Support